import Vue from 'vue'
import _ from 'lodash'
import { sync } from './sync'
// Here are only pure functions that do not affect any state of any element

const patternHex = new RegExp('^#([a-fA-F0-9]){3}$|[a-fA-F0-9]{6}$')

const utils = {
  sync(call) {
    return sync(call)
  },
  // Transform items to integer
  toInteger(item) {
    if (typeof item === 'number') {
      return Math.round(item)
    }

    const number = parseInt(item)

    if (typeof number !== 'number' || isNaN(number)) return 0

    return number
  },

  // Transforms items type string to boolean
  toBoolean(item) {
    if (typeof item === 'string') {
      return item === 'true'
    }
    return item
  },

  // Transforms any type of var in string
  toString(item) {
    if (typeof item === 'boolean') {
      return item ? 'true' : 'false'
    }
    if (typeof item === 'number') {
      return item + ''
    }
    return item
  },

  // Transforms any item to array
  toArray(item) {
    if (Array.isArray(item)) return item
    return [item]
  },

  // Returnes an object with values set to empty strings
  cleanObject(o, callback) {
    return _.cloneDeepWith(o, function (value) {
      const type = typeof value
      if (typeof callback === 'function') {
        if (callback(value)) return ''
      }
      if (type === 'string' || type === 'number' || type === 'undefined' || value === null) return ''
    })
  },

  // append element in DOM
  appendElement(attributes, to) {
    /*
    Example :
      attributes :{
          id: 'productlead-1',
          class: 'productlead_embed',
          typeElem: 'script',
          type: 'text/javascript',
          'data-src': this.URLEmbed + '',
          'data-embed': this.routeEmbedID
        }

      to : document.querySelector('.class')
    */
    if (attributes.id) {
      const old = document.getElementById(attributes.id)

      if (old) to.removeChild(old)
    }

    const script = document.createElement(attributes.typeElem)
    const keys = Object.keys(attributes)

    keys.forEach((key) => {
      if (key !== 'typeElem') {
        script.setAttribute(key, attributes[key])
      }
    })

    // CONDITION TO LOAD NEXT EMBED
    to.appendChild(script)
  },

  // transforms a timestamp number to a date type 19/05/2019 14:22:23
  timestampToDate(timestamp) {
    if (typeof timestamp !== 'number') {
      return '-'
    }
    const date = new Date(timestamp * 1000)

    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
  },

  // Transforms a base64 to an file
  base64File(url, name, sliceSize) {
    try {
      // Split the base64 string in data and contentType
      var block = url.split(';')
      // Get the content type of the image
      var contentType = block[0].split(':')[1] // In this case "image/gif"
      // get the real base64 content of the file
      var b64Data = block[1].split(',')[1] // In this case "R0lGODlhPQBEAPeoAJosM...."

      // return b64toFile(realData,name,contentType)

      contentType = contentType || ''
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }
      return new File(byteArrays, name, { type: contentType })
    } catch (e) {
      console.warn('Error restore File', e)
    }
    return null
  },

  // Lighten (positive number 0-100) and darken(negative number 0-100) hex color
  shadeColor(color, percent) {
    if (typeof color !== 'string' || typeof percent !== 'number' || !patternHex.test(color)) return color
    var R = parseInt(color.substring(1, 3), 16)
    var G = parseInt(color.substring(3, 5), 16)
    var B = parseInt(color.substring(5, 7), 16)

    R = parseInt((R * (100 + percent)) / 100)
    G = parseInt((G * (100 + percent)) / 100)
    B = parseInt((B * (100 + percent)) / 100)

    R = R < 255 ? R : 255
    G = G < 255 ? G : 255
    B = B < 255 ? B : 255

    var RR = R.toString(16).length === 1 ? '0' + R.toString(16) : R.toString(16)
    var GG = G.toString(16).length === 1 ? '0' + G.toString(16) : G.toString(16)
    var BB = B.toString(16).length === 1 ? '0' + B.toString(16) : B.toString(16)

    return '#' + RR + GG + BB
  },

  isBlobInput(item) {
    return (
      typeof item === 'object' &&
      item !== null &&
      typeof item.input === 'object' &&
      typeof item.type !== 'undefined' &&
      item.input.isBlobInput
    )
  },

  reconstructMediaMongo(data) {
    let link = data.permalink ? data.permalink + 'media/?size=m' : data.thumbnail_url
    let type = (data.media_type || '').toLowerCase()

    if (type === 'carousel') {
      type = 'image'
    }
    if (type === 'image') {
      if (data.media_url) link = data.media_url
    }
    const object = {
      id: data._id,
      social_description: data.caption,
      media: {
        low_resolution: {
          url: link,
        },
        standard_resolution: {
          url: link,
        },
      },
      likes: data.likes || data.like_count,
      comments: data.comments || data.comments_count,
      impressions: data.impressions,
      reach: data.reach,
      social_link: data.permalink,
      social_created_at: data.date || data.created_at,
      social_account: data.username,
      type: type,
    }
    if (type === 'video') {
      object.media.video = {
        url: data.media_url,
      }
    }
    return object
  },

  prelucrateData(medias) {
    if (Array.isArray(medias)) {
      for (let i = 0; i < medias.length; i++) {
        medias[i] = this.reconstructMediaMongo(medias[i])
      }
    }

    return medias
  },

  test(call) {
    window.test = (params) => {
      return call(params)
    }
  },

  isNormalInteger(str) {
    var n = Math.floor(Number(str))
    return n !== Infinity && String(n) === str && n >= 0
  },

  isSameQuery(query1, query2) {
    // Check if item is array and compare it sorted or leave the comparation to loadash
    var customizer = function (a, b) {
      return Array.isArray(a) && Array.isArray(b) ? compareArray(a, b) : undefined
    }

    // Sort arrays and compare each item
    var compareArray = (a1, a2) => {
      if (a1.length !== a2.length) return false
      a1 = _.sortBy(a1)
      a2 = _.sortBy(a2)
      for (let i = 0; i < a1.length; i++) {
        if ((_.isObject(a1[i]) || _.isObject(a2[i])) && !_.isEqualWith(a1, a2, customizer)) return false
        if (a1[i] !== a2[i]) return false
      }

      return true
    }

    // Compare queries
    return _.isEqualWith(query1, query2, customizer)
  },
}

Object.freeze(utils)

Vue.prototype.$u = utils
// Vue.prototype._ = _
